import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import ArrayUtils from 'PMT/utils/ArrayUtils';
import { Events } from 'constants';

import SecurityContext from 'utils/permissions/SecurityContext';

import { RestaurantMenuStore } from 'stores';

import { RestaurantMenu } from 'PMT/entities/menu';
import ItemSuggestion from 'PMT/entities/menu/ItemSuggestion';

import AbstractRestaurantMenuComponent from '../components/AbstractRestaurantMenuComponent';

import RoundButton from 'components/RoundButton';
import SuggestionFormModal from './suggestionForm/SuggestionFormModal';

export default class SuggestionsListPage extends AbstractRestaurantMenuComponent {

  state = {
    restaurantMenu: this.props.restaurantMenu.copy(),
    displaySuggestionFormModal: false,
    itemSuggestion: new ItemSuggestion(),
  }

  componentDidMount() {
    RestaurantMenuStore.addListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
  }

  componentWillReceiveProps(nextProps: Object) {
    if (!nextProps.restaurantMenu.equals(this.props.restaurantMenu)) {
      this.setState({
        restaurantMenu: nextProps.restaurantMenu.copy(),
      });
    }
  };

  get restaurantMenu(): RestaurantMenu {
    return this.state.restaurantMenu;
  };

  haveModifications() {
    return !this.state.restaurantMenu.equals(this.props.restaurantMenu);
  };

  onUpdateRestaurantMenuSuccess = () => {
    this.setState({
      loading: false
    });
  };

  onDisplaySuggestionFormModal = (itemSuggestion = null) => {
    this.setState({
      displaySuggestionFormModal: true,
      itemSuggestion,
    });
  };

  onHideSuggestionFormModal = () => {
    this.setState({
      displaySuggestionFormModal: false,
    });
  };

  onSubmitSuggestion = (itemSuggestion) => {
    const restaurantMenu = this.restaurantMenu
    restaurantMenu.suggestions = ArrayUtils.updateObjectOrAdd(restaurantMenu.suggestions, itemSuggestion, suggestion => {
      return _.isEqual(this.state.itemSuggestion, suggestion); 
    });

    this.setState({
      restaurantMenu: restaurantMenu,
      displaySuggestionFormModal: false,
    });
  };

  onDeleteItemSuggestion = (itemSuggestion) => {
    this.restaurantMenu.suggestions = this.restaurantMenu.suggestions.filter((suggestion) => {
      return !_.isEqual(itemSuggestion, suggestion);
    });

    this.setState({
      restaurantMenu: this.restaurantMenu
    });
  }

  renderSuggestionForm() {
    if (!SecurityContext.restaurantMenu.canEdit()) {
      return null
    }
    return (
      <div>
        <RoundButton
          text={I18n.tr('menu.suggestions.form.add_suggestion')}
          onClick={() => this.onDisplaySuggestionFormModal()}
        />

        {this.state.displaySuggestionFormModal &&
          <SuggestionFormModal
            show
            onHide={this.onHideSuggestionFormModal}
            restaurantMenu={this.state.restaurantMenu}
            itemSuggestion={this.state.itemSuggestion}
            onSubmit={this.onSubmitSuggestion}
          />
        }
      </div>
    );
  };

  renderSuggestionsList() {
    return (
      <div className="row suggestions__list top-buffer-30">
        <div className="col-xs-12">
          <table className="table table-hover">
            <tbody>
              {!_.isEmpty(this.restaurantMenu.suggestions) ?
                this.restaurantMenu.suggestions.map((itemSuggestion) => {
                  const linkedItemsToReplace = itemSuggestion.linkedItems.filter((linkedItem) => {
                    return linkedItem.isActionReplace();
                  });
                  const linkedItemsToAdd = itemSuggestion.linkedItems.filter((linkedItem) => {
                    return linkedItem.isActionAdd();
                  });


                  const item = this.restaurantMenu.getItem(itemSuggestion.item)
                  if (_.isNull(item)) {
                    return null
                  }

                  let introductionText = I18n.getForCurrentLocale(itemSuggestion.localizedIntroduction);
                  let introductionTextIsDefault = false;
                  if (_.isEmpty(introductionText)) {
                    introductionText = 'Phrase par défaut';
                    introductionTextIsDefault = true;
                  }

                  return (
                    <tr key={item.id}>
                      <td className="col-xs-2">
                        {item.name}
                      </td>
                      <td className="col-xs-6">
                        {!_.isEmpty(linkedItemsToReplace) &&
                          <div className="row">
                            <label className="col-xs-4 text-right">
                              {I18n.tr('menu.suggestions.form.labelReplace')}
                            </label>
                            <div className="col-xs-8">
                              {linkedItemsToReplace.map((linkedItem) => {
                                const linkedItemItem = this.restaurantMenu.getItem(linkedItem)
                                if (_.isNull(linkedItemItem)) {
                                  return null
                                }
                                return (
                                  <div key={linkedItemItem.id}>
                                    {linkedItemItem.name}
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        }
                        {!_.isEmpty(linkedItemsToAdd) &&
                          <div className="row">
                            <label className="col-xs-4 text-right">
                              {I18n.tr('menu.suggestions.form.labelAdd')}
                            </label>
                            <div className="col-xs-6">
                              {linkedItemsToAdd.map((linkedItem) => {
                                const linkedItemItem = this.restaurantMenu.getItem(linkedItem)
                                if (_.isNull(linkedItemItem)) {
                                  return null
                                }
                                return (
                                  <div key={linkedItemItem.id}>
                                    {linkedItemItem.name}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        }
                      </td>

                      <td className="col-xs-4">
                        <span style={{ fontStyle: introductionTextIsDefault ? 'italic' : '' }}>
                          {introductionText}
                        </span>
                      </td>

                      {SecurityContext.restaurantMenu.canEdit() &&
                        <td className="col-xs-2">
                          <button
                            className="btn btn-xs btn-primary"
                            onClick={() => this.onDisplaySuggestionFormModal(itemSuggestion)}
                          >
                            {I18n.tr('menu.suggestions.form.edit')}
                          </button>

                          &nbsp;

                          <button
                            className="btn btn-xs btn-primary"
                            onClick={() => this.onDeleteItemSuggestion(itemSuggestion)}
                          >
                            {I18n.tr('menu.suggestions.form.delete')}
                          </button>
                        </td>
                      }
                    </tr>
                  )
                }) :
                <tr><td>
                  {I18n.tr('menu.suggestions.suggestions_list_empty')}
                </td></tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  render() {
    if (!SecurityContext.restaurantMenu.canRead()) {
      return (null);
    }

    if (_.isEmpty(this.restaurantMenu) || _.isEmpty(this.restaurantMenu.products)) {
      return (
        <p className="bg-warning">
          {I18n.tr('menu.suggestions.error_no_products_exists')}
        </p>
      );
    }

    return (
      <div className="suggestions top-buffer-30">
        {this.renderSuggestionForm()}
        {this.renderSuggestionsList()}

        {SecurityContext.restaurantMenu.canEdit() &&
          this.renderFixedButtons()
        }
        {this.renderLoading()}
      </div>
    );
  };

}



// WEBPACK FOOTER //
// ./scripts/pages/menu/suggestions/SuggestionsListPage.js